import clsx from "clsx";
import { useState } from "react";
import { Eye, SlashedEye } from "../svg/Auth/Auth";

export const PasswordInput = ({
  type = "text",
  placeholder,
  label,
  className,
  inputClass,
  value,
  onChange,
  ...props
}) => {
  const [view, setView] = useState(false);
  const [maskedValue, setMaskedValue] = useState("");

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    if (view) {
      onChange(e);
    } else {
      const currentPassword = value || "";

      if (inputValue.length < maskedValue.length) {
        // Deleting - trim both password and display
        const newPassword = currentPassword.slice(0, inputValue.length);
        onChange({ ...e, target: { ...e.target, value: newPassword } });
        setMaskedValue(inputValue);
      } else {
        // Adding - get last char and add * to display
        const newChar = inputValue.slice(-1);
        onChange({
          ...e,
          target: { ...e.target, value: currentPassword + newChar },
        });
        setMaskedValue(maskedValue + "*");
      }
    }
  };

  const displayValue = view ? value || "" : maskedValue;

  return (
    <div className={clsx("relative", className)}>
      <label className="text-sm text-primary-black mb-3.5 inline-block">
        {label}
      </label>
      <input
        type="text"
        placeholder={placeholder}
        value={displayValue}
        onChange={handleInputChange}
        className={clsx("base_input bg-[#F8F8F8] !pr-11", inputClass)}
        {...props}
      />
      {
        <div
          onClick={() => setView(!view)}
          className="absolute top-[59%] right-[16px] cursor-pointer"
        >
          {view ? <Eye /> : <SlashedEye />}
        </div>
      }
    </div>
  );
};
